import { createUserStep, createFirmStep } from './lawfirmSteps'

import { assocUserStep, assocStackStep } from './associationSteps'

export const lawfirmOwnerSteps = [createUserStep, createFirmStep]

export const lawfirmUserSteps = [createUserStep]

export const associationMemberSteps = [assocUserStep, assocStackStep]
